import {
  mapState
} from "vuex";

export default {
  computed: {
    ...mapState({})
  },
  data() {
    return {

    }
  },
  methods: {
    // 写入内容
    updateForm(form) {
      console.log('草稿：' + form)
      this.form = form
    },
    // 获取Form内容
    getFormData() {
      this.form = this.$refs.create.getFromData()
    },
  },
  watch: {

  }
}


// WEBPACK FOOTER //
// ./src/Mixins/saveForm.js